import React from 'react';
import { Menu, MenuItem } from '~/UIKit';
import { PrivateLayoutOptions } from '../PrivateLayout';
import { makeStyles } from '~/UIKit/Style';
import { MenuProps } from '@mui/material';

type PrivateLayoutOptionsMenuProps = Omit<MenuProps, 'open'> & {
  handleCloseMenu: () => void;
  options: PrivateLayoutOptions[];
};

const useStyles = makeStyles(
  (theme) => ({
    optionsMenuItem: {
      minWidth: 'auto',

      [theme.breakpoints.up('md')]: {
        minWidth: 128,
      },
    },
  }),
  { name: 'PrivateLayoutOptionsMenu' },
);

export const PrivateLayoutOptionsMenu = ({
  anchorEl,
  handleCloseMenu,
  options,
}: PrivateLayoutOptionsMenuProps) => {
  const { classes } = useStyles();

  return (
    <>
      <Menu anchorEl={anchorEl} keepMounted onClick={handleCloseMenu} open={Boolean(anchorEl)}>
        {options?.map(({ onClick, label }, index) => (
          <MenuItem
            key={`PrivateLayoutTitle_OptionsMenu_${index}`}
            onClick={onClick}
            className={classes.optionsMenuItem}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
